var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.707 7.49966H14C14.1326 7.49966 14.2598 7.55233 14.3536 7.6461C14.4473 7.73987 14.5 7.86705 14.5 7.99966C14.5 8.13226 14.4473 8.25944 14.3536 8.35321C14.2598 8.44698 14.1326 8.49966 14 8.49966H4.707L8.354 12.1457C8.44789 12.2395 8.50063 12.3669 8.50063 12.4997C8.50063 12.6324 8.44789 12.7598 8.354 12.8537C8.26011 12.9475 8.13278 13.0003 8 13.0003C7.86722 13.0003 7.73989 12.9475 7.646 12.8537L3.146 8.35366C3.09944 8.30721 3.0625 8.25203 3.03729 8.19129C3.01208 8.13054 2.99911 8.06542 2.99911 7.99966C2.99911 7.93389 3.01208 7.86877 3.03729 7.80802C3.0625 7.74728 3.09944 7.6921 3.146 7.64566L7.646 3.14565C7.73989 3.05177 7.86722 2.99902 8 2.99902C8.13278 2.99902 8.26011 3.05177 8.354 3.14565C8.44789 3.23954 8.50063 3.36688 8.50063 3.49966C8.50063 3.63243 8.44789 3.75977 8.354 3.85366L4.707 7.49966Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.77c860052cb4ff62e17f2d7b47e71f1b.svg";
export { ForwardRef as ReactComponent };